<template>
  <span>
    <span class="d-md-inline username-label">
      <slot></slot>
    </span>

    <span class="username">
      <avatar :user="$store.state.user" size="xxs2"></avatar>
    </span>
  </span>
</template>

<script>
export default {
  components: {
    Avatar: () => import("@cmp/shared/avatar.vue")
  },
  props: {
    pro: { default: false },
  },
};
</script>

<style scoped lang="scss">

.username {
  display: flex;
  font-weight: 600;

  .pro-badge {
    margin-left: 0.5rem;
    height: 1.6rem;
    font-size: 0.7rem;
  }
}
</style>
